import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { completeAnimation, wheelDegChange } from "../redux/actions";
import { gsap } from 'gsap';
import { Power4, Linear } from "gsap";
import { CustomEase } from "gsap/dist/CustomEase";
import pointer_svg from '../images/wheel/pointer.svg';
import sectors1 from '../images/wheel/sectors-1.svg';
import sectors2 from '../images/wheel/sectors-2.svg';
import sectors3 from '../images/wheel/sectors-3.svg';
import sectors4 from '../images/wheel/sectors-4.svg';
import sectors5 from '../images/wheel/sectors-5.svg';
import sectors6 from '../images/wheel/sectors-6.svg';
import sectors7 from '../images/wheel/sectors-7.svg';
import sectors8 from '../images/wheel/sectors-8.svg';
import sectors9 from '../images/wheel/sectors-9.svg';
import sectors10 from '../images/wheel/sectors-10.svg';
import sectors11 from '../images/wheel/sectors-11.svg';
import sectors12 from '../images/wheel/sectors-12.svg';
import sectors13 from '../images/wheel/sectors-13.svg';
import sectors14 from '../images/wheel/sectors-14.svg';
import sectors15 from '../images/wheel/sectors-15.svg';

CustomEase.create("superWheel", "0, 0.29, 0, 0.39");
const sectors_images = [
    sectors1, sectors2, sectors3, sectors4, sectors5, sectors6, sectors7, sectors8, sectors9, sectors10, sectors11, sectors12, sectors13, sectors14, sectors15
];
//Настройки для каждого кол-ва секторов
const glob_duration = 7;
const sectors_settings = [
    {
        i: 1,//Номер - ни на что не влияет
        lamps: [1],//Какие лампочки зажигать, они же будут крутится по кругу от 1 до 15 в зависимсоти от кол-ва секторов
        prize_offset: 1,//Смещение относительно центра стрелки сектора.
        deg: 90,//Смещение положение сектора по дефолту
        duration: glob_duration,//Длительность анимации вращения
    },
    {
        i: 2,
        lamps: [1],
        prize_offset: 1,
        deg: 0,
        duration: glob_duration,
    },
    {
        i: 3,
        lamps: [1, 3],
        prize_offset: 1,
        deg: -30,
        duration: glob_duration,
    },
    {
        i: 4,
        lamps: [1, 3],
        prize_offset: 1,
        deg: -45,
        duration: glob_duration,
    },
    {
        i: 5,
        lamps: [1, 3, 5],
        prize_offset: 1,
        deg: -55,
        duration: glob_duration,
    },
    {
        i: 6,
        lamps: [1, 3, 5],
        prize_offset: 1,
        deg: -60,
        duration: glob_duration,
    },
    {
        i: 7,
        lamps: [1, 3, 5, 7],
        prize_offset: 1,
        deg: -65,
        duration: glob_duration,
    },
    {
        i: 8,
        lamps: [1, 3, 5, 7],
        prize_offset: 1,
        deg: -70,
        duration: glob_duration,
    },
    {
        i: 9,
        lamps: [1, 3, 5, 7, 9],
        prize_offset: 1,
        deg: -70,
        duration: glob_duration,
    },
    {
        i: 10,
        lamps: [1, 3, 5, 7, 9],
        prize_offset: 1,
        deg: -73,
        duration: glob_duration,
    },
    {
        i: 11,
        lamps: [1, 3, 5, 7, 9, 11],
        prize_offset: 1,
        deg: -75,
        duration: glob_duration,
    },
    {
        i: 12,
        lamps: [1, 3, 5, 7, 9, 11],
        prize_offset: 1,
        deg: -75,
        duration: glob_duration,
    },
    {
        i: 13,
        lamps: [1, 3, 5, 7, 9, 11, 13],
        prize_offset: 1,
        deg: -77,
        duration: glob_duration,
    },
    {
        i: 14,
        lamps: [1, 3, 5, 7, 9, 11, 13],
        prize_offset: 1,
        deg: -78,
        duration: glob_duration,
    },
    {
        i: 15,
        lamps: [1, 3, 5, 7, 9, 11, 13, 15],
        prize_offset: 1,
        deg: -79,
        duration: glob_duration,
    },
];

export const Wheel = () => {
    const dispatch = useDispatch()
    const wheelAnimation = useSelector(state => state.game.wheelAnimation)
    const wheelDeg = useSelector(state => state.game.wheelDeg)
    const gifts_gets = useSelector(state => state.game.gameWheel.gifts)
    const giftId = useSelector(state => state.game.receivedGift.giftId);
    const menuSubitem = useSelector(state => state.app.menuSubitem)

    let gifts = [];
    for (let i = 0; i < gifts_gets.length; i++) {
        if (gifts_gets[i].canBeWon === true) {
            gifts.push(gifts_gets[i]);
        }
    }


    let tl3 = gsap.timeline();

    const prizes_count = gifts.length;
    const prizeSlice = 360 / prizes_count;
    const prizeOffset = Math.floor(180 / prizes_count);

    let deg = wheelDeg === 0 ? 0 : wheelDeg;

    gsap.ticker.lagSmoothing(0);//сглаживание

    function calc_sizes() {
        const diam = document.querySelector('.win-wheel__sectors > img')?.width;
        const sq = Math.floor(diam * Math.PI);
        const s_w = diam;
        const s_h = sq / prizes_count;
        const s_p_l = s_w / 2;
        const s_p_t = s_h / 2;
        document.documentElement.style.setProperty('--s_w', s_w + 'px');
        document.documentElement.style.setProperty('--s_h', s_h + 'px');
        document.documentElement.style.setProperty('--s_p_l', s_p_l + 'px');
        document.documentElement.style.setProperty('--s_p_t', s_p_t + 'px');
    }

    //инициализируем
    useEffect(() => {
        if(menuSubitem !== 'games') return true;
        gsap.to(document.querySelector(".win-wheel__lamps"), {
            rotation: sectors_settings[prizes_count - 1].deg,
            duration: 0
        });
        //Вычислям размеры колеса и секторов чтобы все красиво и ровно было в зависимости от ширины колеса - адаптивность
        let timeout = setTimeout(() => {
            calc_sizes();
            //Плавно показываем колесо без дерганья
            gsap.to(document.querySelector(".win-wheel"), {
                opacity: 1
            });
        }, 250);
        window.addEventListener("resize", () => {
            timeout = setTimeout(() => {
                calc_sizes();
            }, 250);
        });
        return () => clearTimeout(timeout)
    }, [])
    //инициализируем

    //Анимация мигания лампочек в зависмости от настроек sectors_settings
    useEffect(() => {
        let lamps_offset = 0;
        let interval = setInterval(() => {
            const allElements = document.querySelectorAll('.win-wheel__lamp');
            allElements.forEach((element) => {
                element.classList.remove('shine');
            });
            let lamps = sectors_settings[prizes_count - 1].lamps;
            for (let i = 0; i < lamps.length; i++) {
                let shine_lamp = lamps[i] + lamps_offset;
                if (shine_lamp > prizes_count) {
                    shine_lamp = shine_lamp % prizes_count;
                    if (shine_lamp === 0) {
                        shine_lamp = prizes_count;
                    }
                }
                document.querySelector('.win-wheel__lamp-' + shine_lamp).classList.add('shine');
            }
            lamps_offset++;
            if (lamps_offset > prizes_count) {
                lamps_offset = 0;
            }
        }, 350);

        return () => clearInterval(interval)
    }, []);

    function rotate_please(rotation, duration, ease) {
        gsap.to(document.querySelector(".win-wheel__sectors"), {
            rotation: rotation,
            ease: ease,
            duration: duration,
        });
        gsap.to(document.querySelector(".win-wheel__prizes"), {
            rotation: rotation,
            ease: ease,
            duration: duration,
        });
    }


    //Анимация вращения колеса
    useEffect(() => {
        let timeout = null;
        let timeinterval = null;
        if (wheelAnimation) {
            clearTimeout(timeinterval)
            if (giftId > 0) {
                let prize = 0;
                let sector_deg = 360 / prizes_count;
                //Вычисляем порядковый номер выбранного приза
                for (let i = 0; i < prizes_count; i++) {
                    if (gifts[i].id === giftId) {
                        prize = i + 1;
                    }
                }
                if (prize > 0) {

                    //Генерируем случайное вращение барабана на нужный приз
                    deg = (Math.floor(deg / 360) + 1) * 360 + sectors_settings[prizes_count - 1].deg + 6 * 360 + (prize + prizes_count - sectors_settings[prizes_count - 1].prize_offset) * sector_deg;
                    let duration = sectors_settings[prizes_count - 1].duration;
                    rotate_please(deg, duration, "superWheel");
                    tl3.to(document.querySelector('.win-wheel__prize-' + prize + ' > *'), {
                        delay: duration,
                        color: '#FFE500',
                        borderColor: '#FFE500',
                        ease: Power4.easeInOut,
                        duration: .25,
                    }).to(document.querySelector('.win-wheel__prize-' + prize + ' > *'), {
                        color: '#FFF',
                        borderColor: 'rgba(255, 255, 255, 0.30)',
                        ease: Power4.easeInOut,
                        duration: .25,
                    }).to(document.querySelector('.win-wheel__prize-' + prize + ' > *'), {
                        color: '#FFE500',
                        borderColor: '#FFE500',
                        ease: Power4.easeInOut,
                        duration: .25,
                    }).to(document.querySelector('.win-wheel__prize-' + prize + ' > *'), {
                        color: '#FFF',
                        borderColor: 'rgba(255, 255, 255, 0.30)',
                        ease: Power4.easeInOut,
                        duration: .25,
                    });
                    timeout = setTimeout(() => {
                        dispatch(completeAnimation());
                        dispatch(wheelDegChange(deg));
                    }, (duration + 1) * 1000);
                }
            } else {
                deg = deg + 180;
                rotate_please(deg, .25, Linear.easeNone);
                timeinterval = setTimeout(function () {
                    dispatch(wheelDegChange(deg));
                }, 225);
            }
        } else {
            if (giftId === 0) {
                deg = deg + 5;
                rotate_please(deg, .25, Linear.easeNone);

                timeinterval = setTimeout(function () {
                    dispatch(wheelDegChange(deg));
                }, 225)

            }
        }
        return () => {
            clearTimeout(timeout);
            clearTimeout(timeinterval)
        }
    }, [wheelAnimation, giftId, deg]);
    return (
        <div className="win-wheel">
            <div className="win-wheel__sectors">
                <img src={sectors_images[prizes_count - 1]} alt="" title="" />
            </div>
            <div className="win-wheel__prizes">
                {
                    gifts.map(function (item, index) {
                        const rotation = ((prizeSlice * index) * -1) - prizeOffset;
                        const style = {
                            "--rotate": rotation + 'deg',
                        };
                        let cl = 'win-wheel__prize win-wheel__prize-' + (index + 1) + ' prize-size-' + prizes_count;
                        return (<div className={cl}
                            key={index}
                            style={style}>
                            {
                                item.type === 'points' && (
                                    <span className="win-wheel__prize_text">+{item.points}</span>)
                            }
                            {
                                item.type === 'gift' && (
                                    <span className="win-wheel__prize_image"><img src={item.image} alt="" title="" /></span>)
                            }
                        </div>)
                    })
                }
            </div>
            <div className="win-wheel__border">
                <div className="win-wheel__border_ellipse_1"></div>
                <div className="win-wheel__border_ellipse_2"></div>
                <div className="win-wheel__border_ellipse_3"></div>
            </div>
            <div className="win-wheel__lamps">
                {
                    gifts.map(function (item, index) {
                        const rotation = ((prizeSlice * index) * -1) - prizeOffset;
                        const style = {
                            "--rotate": rotation + 'deg',
                        };
                        let cl = 'win-wheel__lamp win-wheel__lamp-' + (index + 1);
                        return (<div className={cl}
                            key={index}
                            style={style}><span /></div>)
                    })
                }
            </div>
            <div className="win-wheel__pointer">
                <img src={pointer_svg} alt="" title="" />
            </div>
        </div>
    )
}